<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="status"
      :label="meta.filter.quickFilter ? '' : $t('Staffing Agency ownership status')"
      :list="statuses"
      :placeholder="$t('All status')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

// List the custom statuses we want to check, but keep in mind that
// the values of each status are in reverse:
// - "false" means not expired
// - "true" means expired
const statuses = [
  { value: false, label: $t('Active') },
  { value: true, label: $t('Expired') },
]

const boolState: ModelRef<boolean | null> = defineModel({
  default: () => null,
})

const status = computed({
  get() {
    if (boolState.value !== null) {
      return boolState.value ? statuses[1] : statuses[0]
    }
    return boolState.value
  },
  set(stateVal: { value: boolean } | null) {
    boolState.value = stateVal !== null ? stateVal.value : null
  },
})
</script>
